import { CookiesStorageService, LocalStorageService } from '@/services';
import { COOKIES_KEYS, LOCAL_STORAGE_KEYS } from '@/constants';
import { getMarketingParams } from './getMarketingParams';

export const getAnalyticsUserProperties = () => {
	const params = getMarketingParams();
	const userPropertyData: Record<string, string | Record<string, string>> = {
		...params,
	};

	if (typeof navigator !== 'undefined') {
		userPropertyData.userAgent = navigator.userAgent;
	}

	const getTestVariant = CookiesStorageService.get(
		COOKIES_KEYS.TEST_VARIANT,
		undefined,
	);
	if (getTestVariant) {
		const getTestName = CookiesStorageService.get(
			COOKIES_KEYS.TEST_NAME,
			'variant',
		);
		userPropertyData[getTestName] = getTestVariant;
	}

	const getEmail = LocalStorageService.get<string | undefined>(
		LOCAL_STORAGE_KEYS.USER_EMAIL,
		undefined,
	);
	if (getEmail) {
		userPropertyData['email'] = getEmail;
		userPropertyData['user entered email'] = getEmail.length ? 'yes' : 'no';
	}

	const getVersion = CookiesStorageService.get(
		COOKIES_KEYS.VERSION_NAME,
		undefined,
	);
	if (getVersion) {
		userPropertyData['landing version'] = getVersion;
	}

	return userPropertyData;
};
